@if (activeSlide == slides.instructions) {
<div sxPadding="medium" sxWidth="full" sxHeight="full" sxCol sxGap="10px" sxDistribution="spaceBetween"
  sxAlign="center">

  <div class="relative h-[280px] w-full">
    <img class="absolute left-1/2 top-1/2 h-[240px] w-[240px] -translate-x-1/2 -translate-y-1/2"
      src="assets/mvmnt-ring.png" alt="">
    <div
      class="absolute left-1/2 top-1/2 flex h-[260px] w-[260px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full">
      <img class="instruction-icon h-[120px] w-[120px]" src="assets/face-icon.png" alt="">
    </div>
  </div>

  <h1>Take a Selfie</h1>

  <super-button sxMargin="0 0 20px" sxWidth="full" iconEnd="chevron-forward" (click)="onStartScanClicked()">Continue
  </super-button>

</div>
}

@if (activeSlide == slides.permission) {
<div sxPadding="medium" sxWidth="full" sxHeight="full" sxCol sxGap="12px" sxAlign="center" sxJustify="center">
  <div class="flex items-center justify-center mt-10 rounded-full size-[80px] bg-red-500/10">
    <ion-icon name="videocam-off" class="text-red-800 size-10"></ion-icon>
  </div>
  <h1 class="text-red-800 text-xl text-center m-0">
    Camera Permission <br> Denied
  </h1>
  <p class="text-center mb-4 text-base">{{ permissionErrorMessage }}</p>

  <div class="rounded-lg bg-ocean-200/60 border border-ocean-200 p-4 w-full mb-4">
    <p class="text-sm font-semibold mb-2">Steps</p>
    <p class="text-sm">1. Go to browser settings</p>
    <p class="text-sm">2. Allow camera access for oneqid.com</p>
    <p class="text-sm">3. Reload this page</p>
  </div>

  <super-button sxWidth="full" (click)="onReloadPermissionsClicked()">Reload now</super-button>
</div>
}

<div [hidden]="activeSlide != slides.capture" sxPadding="medium">


  <div
    class="video-container relative mx-auto flex h-[60vh] w-full min-h-[320px] items-stretch justify-center overflow-hidden rounded-[1.5rem] bg-black"
    [class.video-container--captured]="!!cameraCapturedImageData">

    <div
      class="preview-wrapper relative flex h-full w-full max-w-full min-h-0 min-w-0 flex-1 shrink-0 self-stretch overflow-hidden rounded-[22px] [transform:translateZ(0)]"
      [class.preview-wrapper--captured]="!!cameraCapturedImageData">

      <div
        class="camera-feed-zoom absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 overflow-hidden"
        [class.camera-feed-zoom--faded]="!!cameraCapturedImageData">
        <video #videoElement class="input_video" autoplay playsinline></video>
        <canvas [hidden]="true" #canvasElement></canvas>
      </div>

      <div class="captured-result-layer" [class.captured-result-layer--visible]="!!cameraCapturedImageData"
        aria-hidden="true">
        <canvas #cameraResultCanvas></canvas>
      </div>

      @if (!cameraCapturedImageData) {
      <div
        class="face-oval-overlay pointer-events-none absolute left-1/2 top-1/2 size-full -translate-x-1/2 -translate-y-1/2">
        <div class="face-oval" [class.face-oval-pulse]="!isFaceInsideOval" [class.face-oval-aligned]="isFaceInsideOval">
        </div>
        @if (!isFaceInsideOval) {
        <p class="oval-text text-sm text-white">Align face with oval</p>
        }

      </div>
      }

      <div class="capture-controls absolute bottom-0 left-0 right-0 z-[2] flex items-center justify-center p-4"
        [class.capture-controls--hidden]="!!cameraCapturedImageData">

        <div
          class="capture-button flex size-14 items-center justify-center rounded-full bg-white ring-2 ring-primary cursor-pointer"
          [class.capture-button-disabled]="!isFaceInsideOval" (click)="capture()">
        </div>
      </div>


    </div>




  </div>

  @if (cameraCapturedImageData) {
  <div class="post-capture-actions" sxWidth="full" sxCol sxGap="10px" sxMargin="15px 0">
    <super-button iconEnd="chevron-forward" [isLoading]="isConfirming"
      (click)="onPhotoConfirmed(true)">Confirm</super-button>
    <super-button type="clear" sxBorderWidth="1px" sxBorderColor="primary" sxRadius="medium"
      (click)="onRetakeClicked()">Retake</super-button>
  </div>
  }


</div>